import { NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthModule, StsConfigHttpLoader, AbstractLoggerService, StsConfigLoader, OpenIdConfiguration, LogLevel } from 'angular-auth-oidc-client';
import { environment } from '../../environments';
import { ApplicationConfiguration } from '@model';
import { ClientType } from '@enums';
import { OidcLoggerService } from './oidc-logger.service';

export const httpLoaderFactory = (http: HttpClient) => {
    const configUrl = environment.apiEndpoint + '/appsettings';
    const ownUrl = window.location.protocol + '//' + window.location.host;
    //console.log(`auth-config.module\thttpLoaderFactory\townUrl: ${ownUrl}`);

    let configs$: Observable<OpenIdConfiguration[]> = http.get<ApplicationConfiguration>(configUrl)
        .pipe(
            map(apiConfig => {
                let scopes = apiConfig.scope;
                let brf = {
                    configId: ClientType.Brf,
                    clientId: ClientType.Brf,
                    authority: apiConfig.stsServer,
                    redirectUrl: ownUrl + '/landing',
                    responseType: 'code',
                    scope: scopes.replace('sxit.', 'sxit.brf'),
                    startCheckSession: false,
                    triggerAuthorizationResultEvent: true,
                    autoUserInfo: true,
                    silentRenew: apiConfig.silent_renew,
                    silentRenewUrl: ownUrl + '/silent-renew.html',
                    silentRenewTimeout: 10,
                    forbiddenRoute: '/forbidden',
                    unauthorizedRoute: '/unauthorized',
                    logLevel: apiConfig.log_console_warning_active ? LogLevel.Warn : apiConfig.log_console_debug_active ? LogLevel.Debug : LogLevel.None,
                    maxIdTokenIatOffsetAllowedInSeconds: apiConfig.max_id_token_iat_offset_allowed_in_seconds,
                };
                let company = {...brf, clientId: ClientType.Company, configId: ClientType.Company, scope: scopes.replace('sxit.', 'sxit.company')};
                let villa = {...brf, clientId: ClientType.Private, configId: ClientType.Private, scope: scopes.replace('sxit.', 'sxit.private')};
                let manager = {...brf, clientId: ClientType.Manager, configId: ClientType.Manager, scope: scopes.replace('sxit.', 'sxit.manager')};
                
                //console.log(`auth-config.module\thttpLoaderFactory\toutput`, [ brf, company, villa, manager ]);
                return [ brf, company, villa, manager ];
            })
        );

    return new StsConfigHttpLoader(configs$);
};

@NgModule({
    imports: [
        AuthModule.forRoot({
            loader: {
                provide: StsConfigLoader,
                useFactory: httpLoaderFactory,
                deps: [ HttpClient ],
            }
        })
    ],
    providers: [ { provide: AbstractLoggerService, useClass: OidcLoggerService } ],
    exports: [ AuthModule ]
})
export class AuthConfigModule{}